import { jsx as _jsx } from "react/jsx-runtime";
import BaseMessage from './BaseMessage';
import { ErrorMessageContainer } from '../subcomponents';
const ErrorMessage = ({ id, image, title, subTitle, extraInfo }) => {
    return (_jsx(ErrorMessageContainer, { top: "xxlarge", vertical: "xxlarge", "data-cy": "message-box-container", children: _jsx(BaseMessage, { id: id, image: image, title: title, subTitle: subTitle, extraInfo: extraInfo }) }));
};
export default ErrorMessage;
